export const environment = {
  production: true,

// ------ Local Server
//  baseUrl:"http://localhost:4202/",
//  appUrl:"http://growtherpnepal.com:83/",

//appUrl:"http://localhost:7016/",

// // ------ DataHub Non IRD Server
baseUrl:"https://growtherpnepal.com/",
appUrl:"https://growtherpnepal.com:82/",


// // ------ DataHub School Server
// baseUrl:"http://growtherpnepal.com:85/",
// appUrl:"http://growtherpnepal.com:83/",

//// ------ DataHub IRD Server
// baseUrl:"http://growthloop.com.np/",
// appUrl:"http://growthloop.com.np:81/",

// ------ Asian Server 
// baseUrl:"http://192.168.2.98/",
// appUrl:"http://192.168.2.98:81/",


// ------ Sidhartha Server
// baseUrl:"http://192.168.10.107/",
// appUrl:"http://192.168.10.107:81/",

// //  baseUrl:"http://localhost:80/",
// //  appUrl:"http://localhost:81/",


// ------ Cloud Mitra Non IRD Server
//  baseUrl:"http://app.growtherpnepal.com/",
//  appUrl:"http://app.growtherpnepal.com:81/",


// // baseUrl:"http://45.194.117.159/",
// // appUrl:"http://45.194.117.159:81/",

//baseUrl:"http://localhost:4203/",
// appUrl: 'http://103.191.130.38:81/',
//appUrl:"http://localhost:5135/",
//appUrl:"http://103.191.130.38:81/",
//appUrl:"http://growtherpnepal.com:82/",
//http://192.168.48.91/swagger/index.html
//appUrl:'http://growthloop.com.np:81/',




// name:"(PROD)",
// baseUrl:"http://localhost/growtherp/",
// appUrl: 'https://localhost:7016/',


//appUrlonline: 'http://api.insourceit.com.np/'
  defaultauth: 'fake-backend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};